import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminTagCategoriesIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M15.333 10.084v-.917H13.5V7.334h-.917v1.833H10.75V7.334h-.917v1.833H8v.917h1.833v1.833H8v.917h1.833v1.833h.917v-1.833h1.833v1.833h.917v-1.833h1.833v-.917H13.5v-1.833h1.833Zm-2.75 1.833H10.75v-1.833h1.833v1.833Z" />
    <path d="M6.78 4.667 5.447 3.333H2v8h4.667v1.334H2c-.733 0-1.333-.6-1.333-1.334l.006-8C.673 2.6 1.267 2 2 2h4l1.333 1.333h5.334c.733 0 1.333.6 1.333 1.334V6h-1.333V4.667H6.78Z" />
  </Icon>
);

export default memo(AdminTagCategoriesIcon);
